<template>
    <div class="addwelfare">
        <div class="head-image">
            <img src="../../../assets/bg/addwelfare.png" />
        </div>
        <div class="middle">
            <div v-show='type === 0'>
                <p style="color:#999999;">打开首页的扫一扫，扫描二维码即可添加新的福利卡也可以手动输入对应的卡号卡密</p>
            </div>
            <div v-show="type === 1">
                <div class="card-input"><label>卡号</label><input type="text" placeholder="请输入卡号" v-model="card.cardnum" /></div>
                <div class="card-input"><label>卡密</label><input type="text" placeholder="请输入卡密" v-model="card.cardpwd" /></div>
            </div>
        </div>

        <div class="btn">
           <button>扫一扫</button>
           <button @click="input">{{type | inputbtn}}</button>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            type:0,
            card:{
                cardnum:'',
                cardpwd:'',
            }
        }
    },
    methods:{
        input(){
            if(this.type === 0){
                this.type = 1
            }else if(this.type === 1){
                if(this.card.cardnum === "" || this.card.cardpwd === ""){
                    this.$toast("请输入正确卡密或卡号")

                }else{
                    console.log(this.card)
                    this.$router.replace('/welfare')
                }

            }
        }
    },
    filters:{
        inputbtn(value){
            if(value === 0){
                return "手动输入"
            }else if(value === 1){
                return "确定"
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .addwelfare{
        font-size: 0.28rem;
        text-align: center;
        width: 4.47rem;
        margin: auto;

        .head-image{
            margin: 1rem 0;
            img{
            }   
        }
        .middle{
            .card-input{
                margin:0.1rem 0;
                padding: 0.1rem 0;
                border-bottom: 1px solid rgb(240, 240, 240);
                label{
                    width: 0.5rem;
                    color: #333333;
                }
                input{
                    margin-left: 0.2rem;
                    border: none;
                    background: none;
                }
            }
        }

        .btn{
            text-align: center;
            margin-top: 1rem;
            button{
                @include btn(#FF6161, .72rem);
                display:block;
                width: 100%;
                margin: 0.1rem 0;
            }
        }
    }
</style>
